

export default {
    strict:true,
    state: {
        isUserLoggedIn: false,
        loggedIn:false,
    },
    getters: {
        isLoggedIn: (state)=> {
            return state.loggedIn;
        }
    },
    mutations: {
        setToken (state,token){
            state.token = token;
            if (token) {
                state.isUserLoggedIn = true;
            } else {
                state.isUserLoggedIn = false; 
            }
        },
        setUser (state,user) {
            state.user = user;
        },
        setLoggedId(state,loggedIn) {
          state.loggedIn = loggedIn;
        }
        
    },
    actions: {
        setToken ({commit},token) {
            commit('setToken',token)
        },
        setUser ({commit},user) {
            commit('setUser',user)
        },
        setLoggedIn({commit},loggedIn) {
          commit('setLoggedIn',loggedIn);
        }
    }
}